import { apiFetch } from './client';

export const getCurrentLicense = async () => apiFetch('/api/license/current');

export const getLicenseStatus = async () => apiFetch('/api/license/status');

export const acceptLicense = async ({ licenseVersion, acceptedLicense, acceptedCommercialTerms }) =>
  apiFetch('/api/license/accept', {
    method: 'POST',
    body: {
      licenseVersion,
      acceptedLicense,
      acceptedCommercialTerms,
    },
  });
